/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { array as codecArray } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { FeedbackBase } from './FeedbackBase';
import { GeneralFeedbackCommentBase } from './GeneralFeedbackCommentBase';
import { InlineFeedbackCommentBase } from './InlineFeedbackCommentBase';
import { User } from './User';
const FeedbackWithRepliesParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['type', /* #__PURE__ */ parsers.exactly('feedback-with-replies')],
    [
        'generalComment',
        /* #__PURE__ */ parsers.maybeNull(GeneralFeedbackCommentBase),
        'general_comment',
    ],
    ['user', /* #__PURE__ */ codecArray(InlineFeedbackCommentBase)],
    ['authors', /* #__PURE__ */ codecArray(User)],
]), FeedbackBase);
export class FeedbackWithReplies extends FeedbackBase {
    static decode(input) {
        return FeedbackWithRepliesParser.decode(input).map(res => new FeedbackWithReplies(res));
    }
    static unsafeDecode(input) {
        return FeedbackWithReplies.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return FeedbackWithRepliesParser.encode(data);
    }
    static schema() {
        return FeedbackWithRepliesParser.schema();
    }
}
